import { useCallback } from 'react';
import {
    DIALOG_PORTAL_CONTAINER_ID,
    isMobile,
    unreliableIsMobileDevice,
    useTimeService,
    WithBreakpointRange,
} from '@mews-commander/ui';
import {
    FormTimeDialogPickerField,
    FormTimeDialogPickerFieldProps,
    FormTimePickerField,
    FormTimePickerProps,
    useTimeFieldTransform,
} from '@mews/framework';
import { withBreakpointRange } from '@optimus-web/breakpoints';

type CommonProps = FormTimeDialogPickerFieldProps & FormTimePickerProps;

export type TimeFieldProps = Omit<CommonProps & WithBreakpointRange, 'getTimeService'> & {
    loading?: boolean;
    mode: 'iso' | 'localized';
};

const BaseTimeField = ({ breakpointRange, mode, ...props }: TimeFieldProps) => {
    const isMobileDevice = isMobile(breakpointRange) || unreliableIsMobileDevice();

    const timeService = useTimeService();
    const getTimeService = useCallback(() => timeService, [timeService]);

    const transform = useTimeFieldTransform({ mode, showSeconds: props.showSeconds, timeService });

    const commonProps = {
        getTimeService,
        transform,
        autoComplete: 'off',
    } satisfies Partial<CommonProps>;

    return isMobileDevice ? (
        <FormTimeDialogPickerField portalContainerId={DIALOG_PORTAL_CONTAINER_ID} {...commonProps} {...props} />
    ) : (
        <FormTimePickerField {...commonProps} {...props} />
    );
};

export const TimeField = withBreakpointRange(BaseTimeField);
